<template>
  <div>
    <vue-editor v-model="content" :editor-toolbar="customToolbar" />
    <v-row justify="center" class="ma-1">
      <v-btn text @click="save">save</v-btn>
    </v-row>
  </div>
</template>

<script>
/* eslint-disable no-console */
import { VueEditor } from "vue2-editor";

export default {
  components: { VueEditor },

  data: () => ({
    content: "",
    customToolbar: [
      [{ 'font': [] }],
      [{ 'header': [false, 1, 2, 3,] }],
      ["bold", "italic", "underline"],
      [{ list: "ordered" }, { list: "bullet" }],
      [{color: []}],["link"],['clean'],
    ]
  }),
  methods:{
    save(){
      this.$emit('rich-text-event', this.content)
      this.content = ""
    }
  }
};
</script>